import { ILiveCategoryLinkBulkFailedItemQuery } from '../interfaces/live-category-link-bulk-failed-item.query.interface';

export class LivecategoryLinkFailedItem {
    category: { id: number };
    message: string;

    constructor(query: ILiveCategoryLinkBulkFailedItemQuery) {
        this.category = { id: query.category.id };
        this.message = query.message;
    }
}
